<template>
  <EntityAudit :entity-type="entityName" />
</template>

<script lang="ts">
import { entityAuditApi } from "@/services/endpoints";
import { EntityAudit } from "@modernary/mui/components/audit";
import { defineComponent } from "vue";

export default defineComponent({
  name: "EntityAudits",
  components: {
    EntityAudit,
  },
  props: {
    entityName: {
      type: String,
      required: true,
    },
  },
  setup(props, context) {
    return {
      entityAuditApi,
    };
  },
});
</script>
